import React from 'react';
import { withFormik } from 'formik';
import Collapse from 'react-bootstrap/Collapse';
import './cart-form.css';
import { useTranslation } from 'react-i18next';
import { Formik } from 'formik';

const CartForm = React.memo((props) => {
  const { t } = useTranslation();

  const paymentTypePrivat24 = 'privat24';
  const paymentTypeCash = 'cash';
  const paymentTypeLiqpay = 'liqpay';
  const paymentTypeWayForPay = 'wayforpay';

  const shippingTypeNovaPoshta = 'nova poshta';
  const shippingTypeCourier = 'courier';
  const canShipFromFactory = props.canShipFromFactory;
  const needPrepayment = props.needPrepayment;
  const isFreeShippingTurnedOn = props.isFreeShippingTurnedOn;
  const isLiqpayEnabled = props.isLiqpayEnabled;
  const isWayForPayEnabled = props.isWayForPayEnabled;
  const canPayByCash = props.canPayByCash;
  // const initialPaymentType = isWayForPayEnabled
  //   ? paymentTypeWayForPay
  //   : paymentTypePrivat24;

  const initialPaymentType = paymentTypePrivat24;
  const shippingDates = props.shippingDates;
  return (
    <Formik
      enableReinitialize
      initialValues={{
        name: '',
        lastName: '',
        email: '',
        phone: '',
        paymentType: initialPaymentType,
        shippingType: 'nova poshta',
        city: '',
        warehouse: '',
        comment: '',
        subscribe: true,
      }}
      validate={(values) => {
        const errors = {};

        //console.log("validating!");
        if (!values.name) {
          errors.name = t("Введіть Ім'я");
        }

        if (!values.lastName) {
          errors.lastName = t('Введіть Прізвище');
        }

        if (!values.email) {
          errors.email = t('Введіть Email');
        } else if (
          !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
        ) {
          errors.email = t('Некоректний Email');
        }

        if (!values.phone) {
          errors.phone = t('Введіть Телефон');
        }

        if (!values.city) {
          errors.city = t('Введіть Місто');
        }

        if (values.shippingType === 'nova poshta') {
          if (!values.warehouse) {
            errors.warehouse = t('Введіть Номер відділеня');
          }
        } else if (values.shippingType === 'courier') {
          if (!values.address) {
            errors.address = t('Введіть Повну адресу');
          }
        }

        return errors;
      }}
      onSubmit={(values, actions) => {
        function submitCallback() {
          actions.setSubmitting(false);
        }

        props.onSubmit(values, submitCallback);
      }}
    >
      {(formikProps) => {
        const {
          values,
          touched,
          errors,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
        } = formikProps;

        let liqpayLabel = null;
        if (isLiqpayEnabled) {
          liqpayLabel = (
            <label
              className={
                'form-check-inline u-check g-pl-25 ml-0 g-mr-25 g-mb-10 ' +
                (!isLiqpayEnabled ? ' text-muted' : '')
              }
            >
              <input
                className="g-hidden-xs-up g-pos-abs g-top-0 g-left-0"
                name="radGroupPayment"
                type="radio"
                value={paymentTypeLiqpay}
                checked={values.paymentType === paymentTypeLiqpay}
                onChange={(e) => setFieldValue('paymentType', e.target.value)}
                disabled={isLiqpayEnabled ? false : true}
              />
              <div className="u-check-icon-radio-v4 g-pos-abs g-top-0 g-left-0 g-width-18 g-height-18">
                <i className="g-absolute-centered d-block g-width-10 g-height-10 g-bg-primary--checked"></i>
              </div>
              <span>
                {t('Оплата через')}
                <img
                  className="payment-logo img-fluid g-mx-5"
                  src={process.env.PUBLIC_URL + '/assets/img/logo-liqpay.png'}
                  style={{ height: 14 }}
                />
                {t('карткою')}
                <img
                  className="payment-logo img-fluid  g-ml-5"
                  src={process.env.PUBLIC_URL + '/assets/img/logo-visa.png'}
                />
                <br />
                {canShipFromFactory ? (
                  <>
                    · <b>{t('Безкоштовна')}</b> {t('доставка до відділення НП')}
                    <br />
                  </>
                ) : null}
                · {t('Відсутня комісія за накладений платіж')}
                <br />
                <span>· {t('Відправлення раніше на 1 день')}</span>
              </span>
            </label>
          );
        }

        let wayForPayLabel = null;
        if (isWayForPayEnabled) {
          wayForPayLabel = (
            <label
              className={
                'form-check-inline u-check g-pl-25 ml-0 g-mr-25 g-mb-10 ' +
                (!isWayForPayEnabled ? ' text-muted' : '')
              }
            >
              <input
                className="g-hidden-xs-up g-pos-abs g-top-0 g-left-0"
                name="radGroupPayment"
                type="radio"
                value={paymentTypeWayForPay}
                checked={values.paymentType === paymentTypeWayForPay}
                onChange={(e) => setFieldValue('paymentType', e.target.value)}
                disabled={isWayForPayEnabled ? false : true}
              />
              <div className="u-check-icon-radio-v4 g-pos-abs g-top-0 g-left-0 g-width-18 g-height-18">
                <i className="g-absolute-centered d-block g-width-10 g-height-10 g-bg-primary--checked"></i>
              </div>
              <span>
                {t('Оплата через')}
                <img
                  className="payment-logo img-fluid g-mx-5"
                  src={
                    process.env.PUBLIC_URL + '/assets/img/logo-wayforpay.png'
                  }
                  style={{ height: 14 }}
                />
                {t('карткою')}
                <img
                  className="payment-logo img-fluid  g-ml-5"
                  src={process.env.PUBLIC_URL + '/assets/img/logo-visa.png'}
                />
                <br />
                <span className="g-font-size-12">
                  {canShipFromFactory ? (
                    <>
                      · <b>{t('Безкоштовна')}</b>{' '}
                      {t('доставка до відділення НП')}
                      <br />
                    </>
                  ) : null}
                  · {t('Відсутня комісія за накладений платіж')}
                  {canShipFromFactory ? (
                    <>
                      <br />
                      <span>· {t('Відправлення раніше на 1 день')}</span>
                    </>
                  ) : null}
                </span>
              </span>
            </label>
          );
        }

        var shippingCost = null;
        if (values.paymentType !== 'cash') {
          if (values.shippingType === 'courier') {
            if (canShipFromFactory) {
              if (values.city) {
                var city = values.city.toLowerCase().trim();
                if (
                  city === 'киев' ||
                  city === 'kyiv' ||
                  city === 'київ' ||
                  city === 'kiev'
                ) {
                  shippingCost = 150;
                } else {
                  //shippingCost = 90;
                }
              } else {
                //shippingCost = 70;
              }
            }
          } else if (
            values.shippingType === 'nova poshta' &&
            canShipFromFactory &&
            isFreeShippingTurnedOn
          ) {
            shippingCost = 0;
          }
        }

        var shippingDate = null;
        if (shippingDates) {
          shippingDate = shippingDates.find(
            (d) => d.paymentType === values.paymentType
          )?.date;
        }

        props.onShippingCostChanged(shippingCost);
        return (
          <form onSubmit={handleSubmit}>
            <div>
              <div>
                <div>
                  <div>
                    <div>
                      <i className="fa fa-info-circle"></i>{' '}
                      {t(
                        'Щоб купити декілька товарів, ви можете зробити декілька замовлень. Ми об’єднаємо їх в одне.'
                      )}
                    </div>
                    <div>
                      {t(
                        "Якщо вас цікавить нестандартний розмір або бажаєте внести зміни - зв'яжіться з нами, наприклад, через Viber "
                      )}
                      <a
                        href="viber://chat?number=380665444363"
                        target="_blank"
                        className="g-color-gray-dark-v2"
                      >
                        +380665444363
                      </a>
                    </div>

                    <h3 className="g-mt-20">{t('Покупець')}</h3>
                    <div className="row">
                      <div className="col-sm-6">
                        <div
                          className={
                            'form-group' +
                            (errors.name && touched.name
                              ? ' u-has-error-v1'
                              : '')
                          }
                        >
                          <label className="g-mb-10">{t('Ім’я')}</label>
                          <input
                            className="form-control form-control-md rounded-0"
                            name="name"
                            type="text"
                            autoComplete="given-name"
                            required
                            onChange={handleChange}
                            value={values.name}
                            onBlur={handleBlur}
                          />
                          {errors.name && touched.name ? (
                            <small className="form-control-feedback">
                              {errors.name}
                            </small>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-sm-6 ">
                        <div
                          className={
                            'form-group' +
                            (errors.lastName && touched.lastName
                              ? ' u-has-error-v1'
                              : '')
                          }
                        >
                          <label className="g-mb-10">{t('Прізвище')}</label>
                          <input
                            className="form-control form-control-md rounded-0"
                            name="lastName"
                            type="text"
                            autoComplete="family-name"
                            required
                            onChange={handleChange}
                            value={values.lastName}
                            onBlur={handleBlur}
                          />
                          {errors.lastName && touched.lastName ? (
                            <small className="form-control-feedback">
                              {errors.lastName}
                            </small>
                          ) : null}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-6 g-mb-20--md">
                        <div
                          className={
                            'form-group' +
                            (errors.email && touched.email
                              ? ' u-has-error-v1'
                              : '')
                          }
                        >
                          <label className="g-mb-10">Email</label>
                          <input
                            className="form-control form-control-md rounded-0"
                            name="email"
                            type="email"
                            autoComplete="email"
                            required
                            onChange={handleChange}
                            value={values.email}
                            onBlur={handleBlur}
                          />
                          {errors.email && touched.email ? (
                            <small className="form-control-feedback">
                              {errors.email}
                            </small>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-sm-6 g-mb-20--md">
                        <div
                          className={
                            'form-group' +
                            (errors.phone && touched.phone
                              ? ' u-has-error-v1'
                              : '')
                          }
                        >
                          <label className="g-mb-10">{t('Телефон')}</label>
                          <input
                            className="form-control form-control-md rounded-0"
                            name="phone"
                            type="text"
                            autoComplete="tel"
                            required
                            onChange={handleChange}
                            value={values.phone}
                            onBlur={handleBlur}
                            placeholder={t('Бажано з Viber або Telegram')}
                          />
                          {errors.phone && touched.phone ? (
                            <small className="form-control-feedback">
                              {errors.phone}
                            </small>
                          ) : null}
                        </div>
                      </div>
                    </div>
                    {/* <h3>{t("Спосіб оплати")}</h3>
                    <label className="form-check-inline u-check g-pl-25 ml-0 g-mr-25 g-mb-10">
                      <input
                        className="g-hidden-xs-up g-pos-abs g-top-0 g-left-0"
                        name="radGroupPayment"
                        type="radio"
                        value={paymentTypePrivat24}
                        checked={values.paymentType === paymentTypePrivat24}
                        onChange={(e) =>
                          setFieldValue("paymentType", e.target.value)
                        }
                      />
                      <div className="u-check-icon-radio-v4 g-pos-abs g-top-0 g-left-0 g-width-18 g-height-18">
                        <i className="g-absolute-centered d-block g-width-10 g-height-10 g-bg-primary--checked"></i>
                      </div>
                      <span>
                        {t("Переказ на картку")}
                        <br />
                        <span className="g-font-size-12">
                          {isFreeShippingTurnedOn && canShipFromFactory ? (
                            <>
                              · <b>{t("Безкоштовна")}</b>{" "}
                              {t("доставка до відділення НП")}
                              <br />
                            </>
                          ) : null}
                          · {t("Відсутня комісія за накладений платіж")}
                          {canShipFromFactory ? (
                            <>
                              <br />
                              <span>
                                · {t("Відправлення раніше на 1 день")}
                              </span>
                            </>
                          ) : null}
                        </span>
                      </span>
                    </label>

                    {wayForPayLabel}
                    <label
                      className={
                        "form-check-inline u-check g-pl-25 ml-0 g-mr-25 g-mb-10" +
                        (canPayByCash ? "" : " text-muted")
                      }
                    >
                      <input
                        className="g-hidden-xs-up g-pos-abs g-top-0 g-left-0"
                        name="radGroupPayment"
                        type="radio"
                        value={paymentTypeCash}
                        checked={values.paymentType === paymentTypeCash}
                        disabled={!canPayByCash}
                        onChange={(e) => {
                          setFieldValue("paymentType", e.target.value);
                          setFieldValue("shippingType", shippingTypeNovaPoshta);
                        }}
                      />
                      <div className="u-check-icon-radio-v4 g-pos-abs g-top-0 g-left-0 g-width-18 g-height-18">
                        <i className="g-absolute-centered d-block g-width-10 g-height-10 g-bg-primary--checked"></i>
                      </div>
                      <span>
                        {t("Оплата при отриманні на ")}
                        <img
                          className="img-fluid"
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/img/nova_poshta.jpg"
                          }
                          className="payment-logo"
                        />
                        {canPayByCash ? null : (
                          <span>{t("(Недоступно для обраного розміру)")}</span>
                        )}
                        <br />
                        <span className="g-font-size-12">
                          {needPrepayment ? (
                            <>
                              ·{" "}
                              <b>
                                {t(
                                  "Для замовлень дорожче 1500 грн необхідна 50% передоплата"
                                )}
                              </b>
                              <br />
                            </>
                          ) : null}
                          {isFreeShippingTurnedOn && canShipFromFactory ? (
                            <span>
                              · {t("Сплата покупцем доставки")}
                              <br />
                            </span>
                          ) : null}
                          · {t("Сплата покупцем комісії за наклад. платіж")}
                        </span>
                      </span>
                    </label> */}

                    <h3 className="g-mt-20">{t('Спосіб доставки')}</h3>

                    <label className="form-check-inline u-check g-pl-25 ml-0 g-mr-25">
                      <input
                        id="inputShippingNovaPoshta"
                        className="g-hidden-xs-up g-pos-abs g-top-0 g-left-0"
                        name="radGroupDelivery"
                        type="radio"
                        value={shippingTypeNovaPoshta}
                        checked={values.shippingType === shippingTypeNovaPoshta}
                        onChange={(e) =>
                          setFieldValue('shippingType', e.target.value)
                        }
                        aria-expanded={
                          values.shippingType === shippingTypeNovaPoshta
                        }
                        aria-controls="collapse_shippingTypeNovaPoshta"
                      />
                      <div className="u-check-icon-radio-v4 g-pos-abs g-top-0 g-left-0 g-width-18 g-height-18">
                        <i className="g-absolute-centered d-block g-width-10 g-height-10 g-bg-primary--checked"></i>
                      </div>
                      <span>
                        {t('Доставка до відділення ')}
                        <a
                          href="https://novaposhta.ua/ru/office"
                          target="_blank"
                        >
                          <img
                            className="img-fluid payment-logo"
                            src={
                              process.env.PUBLIC_URL +
                              '/assets/img/nova_poshta.jpg'
                            }
                          />
                        </a>{' '}
                        {t('(Київ і вся Україна)')}
                        <br />
                        {shippingDate ? (
                          <span className="g-font-size-12">
                            · {t('Буде передано до служби доставки')}{' '}
                            {shippingDate}
                          </span>
                        ) : null}
                        <br />
                        <span className="g-font-size-12">
                          ·{' '}
                          {isFreeShippingTurnedOn &&
                          canShipFromFactory &&
                          (values.paymentType === paymentTypePrivat24 ||
                            values.paymentType === paymentTypeWayForPay)
                            ? t('Безкоштовна доставка')
                            : t(
                                'Вартість доставки згідно з тарифами Нової Пошти'
                              )}
                        </span>{' '}
                        <br />
                        <span className="g-font-size-12">
                          · {t('Пакування для транспортування за наш рахунок')}
                        </span>
                      </span>
                    </label>

                    <label
                      className={
                        'form-check-inline u-check g-pl-25 ml-0 g-mr-25' +
                        (values.paymentType === 'cash' ? ' text-muted' : '')
                      }
                    >
                      <input
                        className="g-hidden-xs-up g-pos-abs g-top-0 g-left-0"
                        name="radGroupDelivery"
                        type="radio"
                        value={shippingTypeCourier}
                        checked={values.shippingType === shippingTypeCourier}
                        onChange={(e) =>
                          setFieldValue('shippingType', e.target.value)
                        }
                        disabled={
                          values.paymentType === paymentTypeCash ? true : false
                        }
                        aria-expanded={
                          values.shippingType === shippingTypeCourier
                        }
                        aria-controls="collapse_shippingTypeCourier"
                      />
                      <div className="u-check-icon-radio-v4 g-pos-abs g-top-0 g-left-0 g-width-18 g-height-18">
                        <i className="g-absolute-centered d-block g-width-10 g-height-10 g-bg-primary--checked"></i>
                      </div>
                      <span>
                        {' '}
                        {t('Доставка кур`єром (Київ і вся Україна)')}
                        <br />
                        {shippingDate ? (
                          <span className="g-font-size-12">
                            · {t('Буде передано до служби доставки')}{' '}
                            {shippingDate}
                          </span>
                        ) : null}
                        <br />
                        <span className="g-font-size-12">
                          ·{' '}
                          {canShipFromFactory
                            ? t(
                                'Вартість доставки кур`єром: Київ - 150‎ грн, Україна - згідно з тарифами Нової Пошти'
                              )
                            : t(
                                'Вартість доставки згідно з тарифами Нової Пошти'
                              )}
                        </span>
                        <br />
                        <span className="g-font-size-12">
                          · {t('Пакування для транспортування за наш рахунок')}
                        </span>
                      </span>
                    </label>
                    <div>
                      <Collapse
                        in={values.shippingType === shippingTypeNovaPoshta}
                      >
                        <div id="collapse_shippingTypeNovaPoshta">
                          <div>
                            {t(
                              "Якщо необхідно виконати замовлення ще швидше або щось змінити, зв'яжіться з нами, наприклад, через Viber "
                            )}
                            <a
                              href="viber://chat?number=380665444363"
                              target="_blank"
                              className="g-color-gray-dark-v2"
                            >
                              +380665444363
                            </a>
                          </div>
                          {canShipFromFactory &&
                          (values.paymentType === paymentTypePrivat24 ||
                            values.paymentType === paymentTypeWayForPay) ? (
                            <>
                              <div>
                                {t(
                                  'Відправлення зберігається у відділенні Нової Пошти не більше 5 днів. Потім відправляється назад.'
                                )}
                              </div>
                            </>
                          ) : null}
                          <div className="row g-mt-10">
                            <div className="col-sm-6">
                              <div
                                className={
                                  'form-group' +
                                  (errors.city && touched.city
                                    ? ' u-has-error-v1'
                                    : '')
                                }
                              >
                                <label className="g-mb-10">{t('Місто')}</label>
                                <input
                                  className="form-control form-control-md rounded-0"
                                  name="city"
                                  type="text"
                                  autoComplete="address-level2"
                                  required
                                  onChange={handleChange}
                                  value={values.city}
                                  onBlur={handleBlur}
                                />
                                {errors.city && touched.city ? (
                                  <small className="form-control-feedback">
                                    {errors.city}
                                  </small>
                                ) : null}
                              </div>
                            </div>
                            <div className="col-sm-6">
                              <div
                                className={
                                  'form-group' +
                                  (errors.warehouse && touched.warehouse
                                    ? ' u-has-error-v1'
                                    : '')
                                }
                              >
                                <label className="g-mb-10">
                                  {t('Номер відділення Нової Пошти')}
                                </label>
                                <input
                                  className="form-control form-control-md rounded-0"
                                  name="warehouse"
                                  type="number"
                                  placeholder={t('Тільки цифри')}
                                  onChange={handleChange}
                                  value={values.warehouse}
                                  onBlur={handleBlur}
                                />
                                {errors.warehouse && touched.warehouse ? (
                                  <small className="form-control-feedback">
                                    {errors.warehouse}
                                  </small>
                                ) : null}
                                <div className="text-center">
                                  <a
                                    href="https://novaposhta.ua/ru/office"
                                    target="_blank"
                                  >
                                    {t('Пошук найближчого відділення')}
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-6">
                              <div
                                className={
                                  'form-group' +
                                  (errors.comment && touched.comment
                                    ? ' u-has-error-v1'
                                    : '')
                                }
                              >
                                <label className="g-mb-10">
                                  {t('Коментарі до замовлення')}
                                </label>
                                <textarea
                                  className="form-control form-control-md rounded-0"
                                  name="comment"
                                  onChange={handleChange}
                                  value={values.comment}
                                  onBlur={handleBlur}
                                  rows="3"
                                />
                                {errors.comment && touched.comment ? (
                                  <small className="form-control-feedback">
                                    {errors.comment}
                                  </small>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </div>
                      </Collapse>
                      <Collapse
                        in={values.shippingType === shippingTypeCourier}
                      >
                        <div id="collapse_shippingTypeCourier">
                          <div>
                            {t(
                              "Якщо необхідно виконати замовлення ще швидше або щось змінити, зв'яжіться з нами, наприклад, через Viber "
                            )}
                            <a
                              href="viber://chat?number=380665444363"
                              target="_blank"
                              className="g-color-gray-dark-v2"
                            >
                              +380665444363
                            </a>
                          </div>
                          {canShipFromFactory &&
                          (values.paymentType === paymentTypePrivat24 ||
                            values.paymentType === paymentTypeWayForPay) ? (
                            <>
                              <div>
                                {t(
                                  'Відправлення зберігається у відділенні Нової Пошти не більше 5 днів. Потім відправляється назад.'
                                )}
                              </div>
                            </>
                          ) : null}
                          <div className="row g-mt-10">
                            <div className="col-sm-6">
                              <div
                                className={
                                  'form-group' +
                                  (errors.city && touched.city
                                    ? ' u-has-error-v1'
                                    : '')
                                }
                              >
                                <label className="g-mb-10">{t('Місто')}</label>
                                <input
                                  className="form-control form-control-md rounded-0"
                                  name="city"
                                  type="text"
                                  autoComplete="address-level2"
                                  required
                                  onChange={handleChange}
                                  value={values.city}
                                  onBlur={handleBlur}
                                />
                                {errors.city && touched.city ? (
                                  <small className="form-control-feedback">
                                    {errors.city}
                                  </small>
                                ) : null}
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-6">
                              <div
                                className={
                                  'form-group' +
                                  (errors.address && touched.address
                                    ? ' u-has-error-v1'
                                    : '')
                                }
                              >
                                <label className="g-mb-10">
                                  {t('Адреса доставки')}
                                </label>
                                <textarea
                                  className="form-control form-control-md rounded-0"
                                  onChange={handleChange}
                                  value={values.address}
                                  onBlur={handleBlur}
                                  rows="3"
                                  name="address"
                                  placeholder={t(
                                    'Вкажіть повну адресу доставки'
                                  )}
                                  autoComplete="street-address"
                                />
                                {errors.address && touched.address ? (
                                  <small className="form-control-feedback">
                                    {errors.address}
                                  </small>
                                ) : null}
                              </div>
                            </div>

                            <div className="col-sm-6">
                              <div
                                className={
                                  'form-group' +
                                  (errors.comment && touched.comment
                                    ? ' u-has-error-v1'
                                    : '')
                                }
                              >
                                <label className="g-mb-10">
                                  {t('Коментарі до замовлення')}
                                </label>
                                <textarea
                                  className="form-control form-control-md rounded-0"
                                  name="comment"
                                  onChange={handleChange}
                                  value={values.comment}
                                  onBlur={handleBlur}
                                  rows="3"
                                />
                                {errors.comment && touched.comment ? (
                                  <small className="form-control-feedback">
                                    {errors.comment}
                                  </small>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </div>
                      </Collapse>
                    </div>
                  </div>

                  <label className="form-check-inline u-check g-pl-25">
                    <input
                      className="g-hidden-xs-up g-pos-abs g-top-0 g-left-0"
                      type="checkbox"
                      onChange={(e) =>
                        setFieldValue('subscribe', e.target.checked)
                      }
                      checked={values.subscribe}
                      onBlur={handleBlur}
                    />
                    <div className="u-check-icon-checkbox-v4 g-absolute-centered--y g-left-0">
                      <i className="fa" data-check-icon=""></i>
                    </div>
                    {t(
                      'Я хочу отримувати інформацію про акції та знижки на email'
                    )}
                  </label>

                  <button
                    className="btn btn-block u-btn-primary g-font-size-13 text-uppercase g-py-10 g-my-10 "
                    type="submit"
                  >
                    {t('Підтвердити замовлення')}{' '}
                    <i className="fa fa-arrow-right"></i>
                  </button>
                </div>
              </div>
            </div>
          </form>
        );
      }}
    </Formik>
  );
});

export default CartForm;
